(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-template"]) return;
  try {
    
document.addEventListener("DOMContentLoaded", function () {

  function tagSizeGroupAndTiles() {
    var root = document.querySelector("#infiniteoptions-container");
    if (!root) return false;

    // Find the option block whose visible label is "Size"
    var blocks = Array.from(root.children).filter(function(el) {
      return el.nodeType === 1;
    });

    var sizeBlock = null;

    blocks.forEach(function(block) {
      // Look for a direct label
      var directLabel = block.querySelector(":scope > label");
      var txt = (directLabel ? directLabel.textContent : "")
        .trim()
        .toLowerCase();

      // Fallback: any label that is not an option-value label
      if (!txt) {
        var anyLabel = block.querySelector("label");
        txt = (anyLabel ? anyLabel.textContent : "")
          .trim()
          .toLowerCase();
      }

      if (txt === "size") {
        sizeBlock = block;
      }
    });

    if (!sizeBlock) return false;

    sizeBlock.classList.add("io-size-group");

    // Ensure there is a flex container we can rely on
    var flex = sizeBlock.querySelector("fieldset");

    if (!flex) {
      flex = document.createElement("div");
      flex.className = "io-flex";

      var titleLabel = sizeBlock.querySelector(":scope > label");

      Array.from(sizeBlock.childNodes).forEach(function(n) {
        if (
          n.nodeType === 1 &&
          n.tagName.toLowerCase() === "label" &&
          n === titleLabel
        ) {
          return;
        }

        if (n.nodeType === 3 && !n.textContent.trim()) {
          return;
        }

        flex.appendChild(n);
      });

      sizeBlock.appendChild(flex);
    }

    // Normalize option labels into clickable tiles
    var radios = sizeBlock.querySelectorAll('input[type="radio"]');

    radios.forEach(function(r) {
      var lbl = null;

      // Label wraps the radio
      if (r.closest("label")) {
        lbl = r.closest("label");
      }

      // Separate label associated through "for"
      if (!lbl) {
        var id = r.getAttribute("id");

        if (id) {
          lbl = sizeBlock.querySelector(
            'label[for="' + id.replace(/"/g, '\\"') + '"]'
          );
        }
      }

      if (!lbl) return;

      lbl.classList.add("io-tile");

      // Move label into the flex wrapper if needed
      var wrap = lbl.closest("span") || lbl.parentElement;

      if (wrap && wrap !== flex && wrap.parentElement) {
        flex.appendChild(lbl);
      } else if (lbl.parentElement !== flex) {
        flex.appendChild(lbl);
      }

      // Selected-state sync
      function sync() {
        sizeBlock
          .querySelectorAll("label.io-tile.io-selected")
          .forEach(function(label) {
            label.classList.remove("io-selected");
          });

        radios.forEach(function(rr) {
          var l2 = rr.closest("label.io-tile");

          if (!l2 && rr.id) {
            l2 = sizeBlock.querySelector(
              'label.io-tile[for="' + rr.id + '"]'
            );
          }

          if (l2 && rr.checked) {
            l2.classList.add("io-selected");
          }
        });
      }

      r.addEventListener("change", sync);
      sync();
    });

    return true;
  }

  // Infinite Options can inject the controls after page load
  var tries = 0;

  var timer = setInterval(function() {
    tries++;

    if (tagSizeGroupAndTiles() || tries > 30) {
      clearInterval(timer);
    }
  }, 250);

});

  } catch(e) { console.error(e); }
})();
})();
